import { getters } from './getters'
import { mutations } from './mutations'
import { actions } from './actions'

const state = {
  toDoList: {
    init: 0,
    menu: {},
    tasks: []
  },
  completedToDoList: {
    init: 0,
    menu: {},
    tasks: [],
    loadingNewCompletedToDo: false,
    hasNext: true,
    lastId: 0
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
